import React from 'react';
import "./styles/layout.css"
import { NavLink, Link } from 'react-router-dom';
import Footer from './comps/footer';
import { navRef } from './refs';
export default function Layout(props) {
    return (
        <div className="lo-wrapper">
            <nav className="lo-nav" ref={navRef}>
                <h3>
                    <Link style={{ textDecoration: 'none', color: "white" }} to="/" className="codefreak">
                        <div className="codefreak-box">
                            <div class="lo-container">
                                <span class="react-logo">
                                    <span class="nucleo"></span>
                                </span>
                            </div>
                            <span style={{ fontSize: 'larger', fontFamily: "Courier", letterSpacing: '0.5rem' }}>
                                CodeFreak
                            </span>
                        </div>
                    </Link>
                </h3>
                <ol>
                    <NavLink to="/profile" activeClassName="lo-tab-active">
                        <li>Profile</li>
                    </NavLink>
                    {/* <NavLink to="/discussions" activeClassName="lo-tab-active">
                        <li>Discussions</li>
                    </NavLink> */}
                    <NavLink to="/leaderboard" activeClassName="lo-tab-active">
                        <li>Leader board</li>
                    </NavLink>
                    <NavLink to="/problems" activeClassName="lo-tab-active">
                        <li>Problems</li>
                    </NavLink>
                </ol>
            </nav>
            {props.children}
            <Footer />
        </div>
    )
}